const BrokerRecruitmentForm = require('./lum-broker-recruitment-form.js');

(($) => {
    $(document).on('ready', init);

    function init() {
        bind();
    }

    function bind() {
        $('html').on('bb-lumeris:lum-broker-recruitment-form:init', moduleInit);
    }

    function moduleInit(event, data) {
        if (!event || !data) {
            return false;
        }

        const $module = $(`.fl-node-${data.node}`);
        const module = new BrokerRecruitmentForm($module, data);
    }
})(jQuery);